import type { TFunction } from "i18next";

export const InstitutionType = {
  HOSPITAL: "HOSPITAL",
  ACADEMIC: "ACADEMIC",
} as const;

export type InstitutionType =
  (typeof InstitutionType)[keyof typeof InstitutionType];

// Labels are translated at call time (not a static map) since this file
// sits outside the React tree and has no access to the active language.
export const getInstitutionTypeLabel = (
  type: InstitutionType,
  t: TFunction,
): string => {
  const labels: Record<InstitutionType, string> = {
    HOSPITAL: t("signup.institutionTypeHospital", { ns: "auth" }),
    ACADEMIC: t("signup.institutionTypeAcademic", { ns: "auth" }),
  };
  return labels[type];
};

export const SignupPurpose = {
  DEMO_REQUEST: "DEMO_REQUEST",
  ONBOARD: "ONBOARD",
} as const;

export type SignupPurpose = (typeof SignupPurpose)[keyof typeof SignupPurpose];

export const getSignupPurposeLabel = (
  purpose: SignupPurpose,
  t: TFunction,
): string => {
  const labels: Record<SignupPurpose, string> = {
    DEMO_REQUEST: t("signup.purposeDemoRequest", { ns: "auth" }),
    ONBOARD: t("signup.purposeOnboard", { ns: "auth" }),
  };
  return labels[purpose];
};
